import * as Icon from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row } from "antd";
import { ColumnsType } from "antd/es/table";
import Search from "antd/lib/input/Search";
import { useEffect } from "react";
import { AtivoModel } from "../../models/ativoModel";
import { PlanoContaContabilDTOModel } from "../../models/planoContaContabil/planoContaContabilDTOModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import {
  setEntityPlanoContaContabil,
  setBuscaPlanoContaContabil,
  setModalCadastrarPlanoContaContabil,
  setModalDeletarPlanoContaContabil,
} from "../../redux/slices/planoContaContabil/planoContaContabilSlice";
import { atualizarPlanoContaContabilAtivo, buscarPlanoContaContabil, deletarPlanoContaContabil } from "../../services/planoContaContabilService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroEdicaoPlanoContaContabil from "./modals/cadastrar";
import { BuscaContaContabilModel } from "../../models/planoContaContabil/buscaContaContabilModel";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import { removeFilhos } from "../../util/functions/removeFilhos";
import { SwitchComponent } from "../../components/button/switch";

const PlanoContaContabil = () => {
  //estados globais
  const planoContaContabilState = useAppSelector((state) => state.planoContaContabil);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(planoContaContabilState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("PLANO DE CONTA CONTÁBIL"));
    dispatch(buscarPlanoContaContabil({ ...planoContaContabilState.busca, ativo: true }));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityPlanoContaContabil({}));
    dispatch(setModalCadastrarPlanoContaContabil(true));
  };

  const goEditar = (value: PlanoContaContabilDTOModel) => {
    dispatch(setEntityPlanoContaContabil(value));
    dispatch(setModalCadastrarPlanoContaContabil(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarPlanoContaContabil(false));
  };

  const goDeletar = async (value: PlanoContaContabilDTOModel) => {
    dispatch(setEntityPlanoContaContabil(value));
    dispatch(setModalDeletarPlanoContaContabil(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarPlanoContaContabil(false));
  };

  const onChangeAtivo = (value: PlanoContaContabilDTOModel) => {
    let args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarPlanoContaContabilAtivo({ value: args, busca: planoContaContabilState.busca }));
  };

  const onSearch = (value: string) => {
    let busca: BuscaContaContabilModel = { ...planoContaContabilState.busca, denominacao: value };

    dispatch(buscarPlanoContaContabil(busca));
    dispatch(setBuscaPlanoContaContabil(busca));
  };

  const onChangeTable = (pagination: any, filters: any) => {
    let busca: BuscaContaContabilModel = { ...planoContaContabilState.busca };

    if (filters.ativo !== null) {
      if (filters.ativo.length === 2) {
        busca.ativo = null;
      }
      if (filters.ativo.length === 1) {
        if (filters.ativo[0] === "true") {
          busca.ativo = true;
        }
        if (filters.ativo[0] === "false") {
          busca.ativo = false;
        }
      }
    } else {
      busca.ativo = null;
    }

    dispatch(setBuscaPlanoContaContabil(busca));
    dispatch(buscarPlanoContaContabil(busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
      disabled: (item: any) => item.filhos !== undefined,
    },
  ];

  const columns: ColumnsType<PlanoContaContabilDTOModel> = [
    {
      title: "PLANO DE CONTA CONTÁBIL",
      dataIndex: "denominacaoCompleta",
    },
    {
      title: "DESCRIÇÃO",
      dataIndex: "descricao",
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Conta contábil ou Descrição" onSearch={onSearch} className="searchInput" enterButton style={{ width: 400 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        loading={planoContaContabilState.loading}
        data={removeFilhos(planoContaContabilState.list)}
        columns={columns}
        expandable={{
          childrenColumnName: "filhos",
          expandRowByClick: true,
        }}
        tableProps={{
          className: "tableCentroCusto",
          onChange: onChangeTable,
        }}
      />
      <Modal
        title={editar ? "EDITAR PLANO DE CONTA CONTÁBIL" : "NOVO PLANO DE CONTA CONTÁBIL"}
        centered
        width={835}
        open={planoContaContabilState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroEdicaoPlanoContaContabil />
      </Modal>
      <Modal title={"REMOVER CONTA CONTÁBIL"} centered width={350} open={planoContaContabilState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover a conta contábil?"
          action={deletarPlanoContaContabil({ value: planoContaContabilState.entity.id, busca: planoContaContabilState.busca })}
          close={setModalDeletarPlanoContaContabil(false)}
        />
      </Modal>
    </Flex>
  );
};
export default PlanoContaContabil;
